import React, { Component } from 'react';
import { Circle } from 'rc-progress';
import PropTypes from 'react-proptypes';

export default class CircularProgress extends Component {

    static propTypes = {
        percent: PropTypes.number,
    };

    static defaultProps = {
        percent: 0,
    };

    constructor(props) {
        super(props);

        this.state = {
            progress: 0,
        };
    }

    componentDidMount() {
        const { percent } = this.props;
        if (percent > 0) {
            this.interval = setInterval(
                () => this.setState((prevState) => {
                    if (prevState.progress < percent) {
                        return { progress: ++prevState.progress };
                    }

                    clearInterval(this.interval);
                    return { progress: prevState.progress };
                }),
                20,
            );
        }
    }

    componentWillReceiveProps(nextProps) {
        const { progress } = this.state;
        if (nextProps.percent && nextProps.percent !== progress) {
            this.setState({ progress: nextProps.percent });
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { percent, ...rest } = this.props;
        const { progress } = this.state;

        return (
            <Circle
                trailWidth={6}
                trailColor="#E3E7EF"
                strokeWidth={6}
                strokeColor="#7740f9"
                percent={progress}
                {...rest}
            />
        );
    }

}
